module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/muttertag-10d635def8386790f446daf03afea0dc.svg";